import { inject, bindable } from 'aurelia';

@inject(Element)
export class GotoAnchorCustomAttribute {
  @bindable value;

  constructor(element) {
    this.element = element;
    this.onClick = (event) => {
      event.preventDefault();
      const target = document.getElementById(this.value);
      if (target !== null) {
        target.scrollIntoView();
      }
    };
  }

  attached() {
    this.element.addEventListener('click', this.onClick);
  }

  detaching() {
    this.element.removeEventListener('click', this.onClick);
  }
}
